import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	lozengeButtonLabel: {
		id: 'software.main.board-container.board.swimlane.increment-planning-swimlane-content.lozenge-button-label',
		defaultMessage: 'More info about team details',
		description: 'Label for the button that shows the lozenge tooltip',
	},
});
